import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-type-variant",
  "use": "icon-type-variant-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-type-variant\"><path d=\"M14 4v10H4V4zm-2 2H6v6h6zm11-2a5 5 0 1 1 0 10 5 5 0 0 1 0-10m0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6m5 12v10H18V18zm-2 2h-6v6h6zm-12-2v10H4V18zm-2 2H6v6h6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol